import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { adminGuard, fabTracGuard, readGuard } from './shared/guards/guards';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    canActivate: [MsalGuard, readGuard],
    loadChildren: () => import('./features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
  },
  {
    path: 'reports',
    canActivate: [MsalGuard, readGuard],
    loadChildren: () => import('./features/reports/reports.routes').then((m) => m.REPORTS_ROUTES),
  },
  {
    path: 'rolls',
    canActivate: [MsalGuard, readGuard],
    loadChildren: () => import('./features/rolls/rolls.routes').then((m) => m.ROLLS_ROUTES),
  },
  {
    path: 'machines',
    canActivate: [MsalGuard, readGuard],
    loadChildren: () => import('./features/machines/machines.routes').then((m) => m.MACHINES_ROUTES),
  },
  {
    path: 'alerts',
    canActivate: [MsalGuard, readGuard],
    loadChildren: () => import('./features/alerts/alerts.routes').then((m) => m.ALERTS_ROUTES),
  },
  {
    path: 'general-admin',
    canActivate: [MsalGuard, adminGuard],
    loadChildren: () => import('./features/general-admin/general-admin.routes').then((m) => m.GENERAL_ADMIN_ROUTES),
  },
  {
    path: 'notification-history',
    canActivate: [MsalGuard, readGuard],
    loadChildren: () =>
      import('./features/notification-history/notification-history.routes').then((m) => m.NOTIFICATION_HISTORY_ROUTES),
  },
  {
    path: 'user-profile',
    canActivate: [MsalGuard, readGuard],
    loadChildren: () => import('./features/user-profile/user-profile.routes').then((m) => m.USER_PROFILE_ROUTES),
  },
  {
    path: 'learning-platform',
    canActivate: [MsalGuard, readGuard],
    loadChildren: () =>
      import('./features/learning-platform/learning-platform.routes').then((m) => m.LEARNING_PLATFORM_ROUTES),
  },
  {
    path: 'fabtrac',
    canActivate: [MsalGuard, fabTracGuard],
    loadChildren: () => import('./features/fabtrac/fabtrac.routes').then((m) => m.FABTRAC_ROUTES),
  },
  {
    // Users without the Read permission (e.g. no role assigned) end up here; only sign-in is required.
    path: 'no-access',
    canActivate: [MsalGuard],
    loadComponent: () => import('./features/no-access/no-access.component').then((m) => m.NoAccessComponent),
  },
  {
    path: '404',
    loadComponent: () => import('./features/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
  {
    path: '**',
    redirectTo: '404',
  },
];
